<template>
  <div>
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      :color="color"
      :loader="loader">
    </loading>
    <h3 class="page-header">Order Ratings Report</h3>
    <div class="report-wrapper">
      <div class="row report-inputs">
        <div ref='partner_select' class="col-md-3">
          <multiselect
            v-model="np_selected"
            :options="nationalPartners"
            :multiple="true"
            pen-direction="bottom"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Choose National Partner(s)"
            label="NAME"
            track-by="CODE"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false"
            :taggable="true"
            @close="getRestaurants()">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="np_selected.length" @mousedown.prevent.stop="clearAllNP()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isNPInvalid">Must select at least one value</label>
        </div>
        <div ref='selected' class="col-md-3">
          <multiselect
            v-model="selected"
            :options="restaurants"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="true"
            :allow-empty="true"
            :preserve-search="true"
            placeholder="Choose Restaurant(s)"
            label="storeDisplay"
            track-by="externalId"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="selected.length" @mousedown.prevent.stop="clearAllRestos()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isRestInvalid">Must select at least one value</label>
        </div>
        <div class="col-md-2">
          <datepicker v-model="start_date" placeholder="Start Date"></datepicker>
        </div>
        <div class="col-md-2">
          <datepicker v-model="end_date" placeholder="End Date"></datepicker>
        </div>
        <div class="col-md-2">
          <button id="btn" class="btn btn-primary btn-fill" :disabled="btnDissabled == 1" v-on:click="getRatingsReport">Generate Report</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="downloads" ref="downloads" v-if="seen">
              <button v-on:click="exportTableToCSV('ratings_report.csv')" class="btn btn-default"><i class="ti-layout"></i> CSV</button>
            </div>
            <div class="header">
              <slot name="header">
                <h4 class="title">{{table.title}}</h4>
              </slot>
            </div>
            <div v-if="seen" class="content table-responsive table-full-width">
              <table class="table table-hover">
              <thead>
                <tr>
                  <th v-for="column in table.columns">
                    <span v-if="column == 'Google Review'" class="tooltip_underline" v-tooltip.top-center="'Customer clicked link to leave a positive review on Google.'">{{column}}</span>
                    <span v-else>{{column}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key, index) in table.data">
                  <td>{{item.STORE_NUMBER}}</td>
                  <td>{{item.OID}}</td>
                  <td><a target="_blank" v-bind:href="item.DSP_URL">{{item.DSP_NAME}}</a></td>
                  <td>{{item.SOURCE}}</td>
                  <td>{{item.RATED_ON}}</td>
                  <td>{{item.RATINGTYPE}}</td>
                  <td v-if="item.NAME">{{item.NAME + ' - ' + item.CITY + ', ' + item.STATE + ', ' + item.RZIP}}</td>
                  <td v-else></td>
                  <td v-if="item.GOOGLE_REVIEWED">{{item.GOOGLE_REVIEWED}}</td>
                  <td v-else-if="item.TOTAL_GOOGLE_REVIEWS" v-tooltip.left="'Total # of Google Reviews left during selected time period.'"><span class="tooltip_underline">{{item.TOTAL_GOOGLE_REVIEWS}}</span></td>
                  <td v-if="item.RATING">{{item.RATING}}</td>
                  <td v-else-if="item.AVERATING" v-tooltip.left="'Average Score of Internal Reviews.'"><span class="tooltip_underline">{{item.AVERATING}}</span></td>
                  <td style="width: 300px">{{item.COMMENTS}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import {API} from 'src/api';
  import moment from 'moment';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }

  export default {
    components: {
      Loading
    },
    data () {
      return {
        start_date: moment().subtract(1, 'days').toString(),
        end_date: moment().toString(),
        table: {
          title: 'Please select your criteria above.',
          columns: [],
          data: [],
          rids: []
        },
        seen: false,
        np_hidden: false,
        np_selected: [],
        selected: [],
        nationalPartners: [],
        restaurants: [],
        isLoading: false,
        fullPage: true,
        height: 128,
        width: 128,
        color: '#0647A6',
        loader: 'bars'
      }
    },
    computed: {
      isNPInvalid () {
        if(this.np_selected.length === 0)
          return true
      },
      isRestInvalid () {
        if(this.selected.length === 0)
          return true
      },
      btnDissabled () {
        if(this.np_hidden) {
          if(this.selected.length === 0) {
            return true
          } else {
            return false
          }
        } else {
          if(this.selected.length === 0 || this.np_selected.length === 0) {
            return true
          } else {
            return false
          }
        }
      }
    },
    methods: {
      getRatingsReport () {
        this.isLoading = true
        var startDate = moment(String(this.start_date)).format('YYYY-MM-DDTHH:mm:ss')
        var endDate = moment(String(this.end_date)).format('YYYY-MM-DDTHH:mm:ss')
        var self = this
        var rid = []
        var company = []
        var extid = []
        self.table.title = ''
        self.table.columns = ''
        self.table.data = ''
        self.seen = false

        // Restaurants
        if (this.selected.length > 0) {
          if(this.selected[0].externalId === 'selectAll') {
            for (let rest of Object.values(this.restaurants)) {
              if(rest.externalId !== 'selectAll') extid.push(rest.EXTIDs)
            }
          } else {
            for (let rest_sel of Object.values(this.selected)) {
              extid.push(rest_sel.EXTIDs)
            }
          }
        }
        // National Partners
        if(this.np_selected.length > 0) {
          if(userInfo.company != 'Support' && this.np_selected[0].CODE === 'selectAll') {
            company = userInfo.company
          }
          else if(userInfo.company == 'Support' || this.np_selected[0].CODE != 'selectAll') {
            for (let np_sel of Object.values(this.np_selected)) {
              company.push(np_sel.CODE)
            }
          }
          else {
            company = userInfo.company
          }
        } else {
          company = userInfo.company
        }

        API.post('/report/order_ratings', {
          np: company,
          extid: extid,
          interval: startDate + '/' + endDate
        })
        .then(function (response) {
          console.log('getRatingsReport', response)
          if (response.data.status === 200) {
            self.table.title = 'Order Ratings'
            self.table.columns = ['Store #', 'Order #', 'DSP', 'Source', 'Order Placed', 'Type', 'Restaurant', 'Google Review', 'Rating', 'Comments']
            self.table.data = response.data.rv
            self.seen = true
            self.isLoading = false
          } else {
            self.table.title = response.data.message
            self.table.columns = ''
            self.table.data = ''
            self.seen = false
            self.isLoading = false
          }
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = false
          self.alert = 'Your request has timed out. Please refine your search and try again.'
        })
      },
      getRestaurants () {
        var self = this
        var company = []
        self.restaurants = []
        self.selected = []

        if(this.np_selected.length > 0) {
          if(userInfo.company != 'Support' && this.np_selected[0].CODE === 'selectAll') {
            company = userInfo.company
          }
          else if(userInfo.company == 'Support' || this.np_selected[0].CODE != 'selectAll') {
            for (let np_sel of Object.values(this.np_selected)) {
              company.push(np_sel.CODE)
            }
          }
          else {
            company = userInfo.company
          }
        } else {
          company = userInfo.company
        }

        self.restaurants = [{ externalId: 'selectAll', storeDisplay: 'All Restaurants' }]
        API.get('/restaurant/NP?np=' + company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)
        .then(function (response) {
          if(response.data.entities) {
            for (let rest of Object.values(response.data.entities)) {
              self.restaurants.push(rest)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getNationalPartners () {
        var self = this
        if(userInfo.company != 'Support') self.nationalPartners = [{ CODE: 'selectAll', NAME: 'All Partners' }]
        API.get('/report/partners?np=' + userInfo.company)
        .then(function (response) {
          for (let np of Object.values(response.data.rv)) {
            self.nationalPartners.push(np)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      clearAllNP () {
        this.np_selected = []
      },
      clearAllRestos () {
        this.selected = []
      }
    },
    mounted () {
      var company = userInfo.company.split(',');
      if(company == 'Support' || company.length > 1) {
        this.getNationalPartners()
      }
      if(company != 'Support' && company.length == 1) {
        this.getRestaurants()
        this.$refs.partner_select.hidden = true
        this.np_hidden = true
      }
    }
  }
</script>
<style scoped>
th {
    padding-bottom: 10px !important;
}
#btn {
  width: 100%;
}
.table thead > th {
    padding: 0 8% 5px 0;
}

.table > tbody > tr > td {
    padding: 5px 1% 5px 0;
}

table>tbody>tr:last-child {
  font-weight: 600;
  background: #e3e3e3;
}

</style>



// WEBPACK FOOTER //
// OrderRatings.vue?57115dde